(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/models/contact.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/models/contact.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.customer_service.models.Contact = Backbone.Model.extend({
    url: svs.core.jupiter.url() + '/supportive/categories/subjects',

    initialize: function() {
      var fetchOptions = {
        error: function(collection, response) {
          svs.customer_service_logger.error('Error in fetching contacts subjects: ' + JSON.stringify(response));
        },
        success: function(collection, response) {
          svs.customer_service_logger.debug('Has fetched ' + response.subjects.length + ' subjects');
        }
      };
      this.set('isLoggedIn', svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER));
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        if (svs.customer_service.data.properties) {
          this.set({ customerId: svs.customer_service.data.properties.customerId, email: svs.customer_service.data.properties.email });
        } else {
          this.getUserCredentials();
        }
      } else {
        this.set({ customerId: '', email: '' });
      }
      this.set('chat', svs.customer_service.data.config.chat);
      this.set('chatBot', svs.customer_service.data.config.chatBot);
      this.set('phone', svs.customer_service.data.config.phone);
      this.set('messageSupport', svs.customer_service.data.config.messageSupport);

      svs.customer_service.data.contactFormSubjects ? this.set(svs.customer_service.data.contactFormSubjects) : this.fetch(fetchOptions);

      delete svs.customer_service.data.properties;
      delete svs.customer_service.data.contactFormSubjects;
    },
    parse: function(response) {
      return {
        subjects: {
          subjects: response.subjects,
          hasSelected: _.some(response.subjects, function(item) {
            return item.selected === true;
          })
        }
      };
    },
    postQuestionToCustomerService: function(data, successFn, errorFn) {
      if (this.get('customerId').length > 6) {
        data.customerId = this.get('customerId');
      }
      var options = {
        method: 'PUT',
        path: '/supportive/supportmessages',
        data: data
      };
      svs.core.jupiter.call(options, successFn, errorFn);
    },

    getUserCredentials: function() {
      var self = this,
        options = {
          method: 'GET',
          path: '/player/properties?propertyList=customerId,email'
        };

      svs.core.jupiter.call(
        options,
        function(response) {
          self.set('customerId', response.playerProperties.customerId);
          self.set('email', response.playerProperties.email);
        },
        function() {
          svs.customer_service_logger.warn('error getting playerProperties from jupiter');
        }
      );
    }
  });
})(Backbone, _, svs);

 })(window);